export class RouterConstants {
    public static readonly ReturnUrlQueryParameterName = 'returnUrl';
    public static readonly BookingIdQueryParameterName = 'bookingId';
    public static readonly RegisterFromBookingPage = "isFromBookingPage";
    public static readonly AsConsumer = 'asConsumer';
}
